export const longpress = {
    beforeMount(el: any, binding: any) {
        let pressTimer: ReturnType<typeof setTimeout> | null = null;
    
        const start = (e: MouseEvent | TouchEvent) => {
            if (e.type === 'click' && (e as MouseEvent).button !== 0) {
                return;
            }
            if (pressTimer === null) {
                pressTimer = setTimeout(() => {
                    // e.stopPropagation();
                    // e.preventDefault();
                    pressTimer = null;

                    binding.value(e);
                }, 500);
            }
        };
    
        const cancel = (e: MouseEvent | TouchEvent) => {
            if (pressTimer !== null) {
                clearTimeout(pressTimer);
                pressTimer = null;

                // e.stopPropagation();
                // e.preventDefault();
            }
        };

        el.addEventListener('mousedown', start);
        el.addEventListener('touchstart', start);
        el.addEventListener('click', cancel);
        el.addEventListener('mouseout', cancel);
        el.addEventListener('touchend', cancel);
        el.addEventListener('touchcancel', cancel);

        // Prevent the context menu
        el.addEventListener('contextmenu', (e: Event) => {
            e.preventDefault();
        });
    }
}
